export default function formDataAppendFile(formData: FormData, fieldName: string, file: any) {
  "name" in file
    ? formData.append(fieldName, file, file.name)
    : formData.append(fieldName, file);
}